import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useInventoryState } from '../../../../../hooks';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { ExperienceOpening } from '../../../../../utils/experiences';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import type { ExperienceRowProps } from '../../types';

const ExperienceBookedRowComponent: React.FC<ExperienceRowProps> = ({
  experienceId,
}) => {
  const { endOfSaleDate } = useInventoryState();
  const { inventoryExperiences, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Experiences
  );

  if (!inventoryExperiences) {
    return null;
  }

  return (
    <TableRow>
      <LabelCell label="Booked units" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${experienceId}`];
        const bookedStockFieldName = [...fieldName, 'bookedStock'];
        const isGrayed =
          isDatePast(dateKey) || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: ExperienceOpening) => {
              return (
                <LabelValueCell
                  value={values?.bookedStock ?? 0}
                  date={dateKey}
                  name={bookedStockFieldName}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const ExperienceBookedRow = React.memo(ExperienceBookedRowComponent);
